// The key is Froala's generic unlock constant; only the 2.3.x build accepts it (see
// docs/modules/newsletters/debugging.md).
const BASE_OPTIONS = {key: "AODOd2HLEBFZOTGHW==", language: "nl"}

const NOTE_TOOLBAR = [
  "fullscreen",
  "bold",
  "italic",
  "underline",
  "strikeThrough",
  "subscript",
  "superscript",
  "|",
  "fontFamily",
  "fontSize",
  "color",
  "inlineStyle",
  "paragraphStyle",
  "|",
  "paragraphFormat",
  "align",
  "formatOL",
  "formatUL",
  "outdent",
  "indent",
  "quote",
  "-",
  "insertTable",
  "|",
  "emoticons",
  "specialCharacters",
  "insertHR",
  "selectAll",
  "clearFormatting",
  "|",
  "print",
  "help",
  "|",
  "undo",
  "redo",
]

const FULL_TOOLBAR = [
  "fullscreen",
  "bold",
  "italic",
  "underline",
  "strikeThrough",
  "subscript",
  "superscript",
  "|",
  "fontFamily",
  "fontSize",
  "color",
  "inlineStyle",
  "paragraphStyle",
  "|",
  "paragraphFormat",
  "align",
  "formatOL",
  "formatUL",
  "outdent",
  "indent",
  "quote",
  "-",
  "insertLink",
  "insertImage",
  "insertVideo",
  "insertTable",
  "|",
  "emoticons",
  "specialCharacters",
  "insertHR",
  "selectAll",
  "clearFormatting",
  "|",
  "print",
  "help",
  "|",
  "undo",
  "redo",
]

export const PRESETS = {
  full: {toolbarButtons: FULL_TOOLBAR},
  note: {toolbarButtons: NOTE_TOOLBAR},
  article: {toolbarButtons: NOTE_TOOLBAR, paragraphFormatSelection: true},
  inline: {
    toolbarInline: true,
    charCounterCount: false,
    toolbarButtons: [
      "bold",
      "italic",
      "underline",
      "strikeThrough",
      "color",
      "emoticons",
      "-",
      "paragraphFormat",
      "align",
      "formatOL",
      "formatUL",
      "indent",
      "outdent",
      "-",
      "insertImage",
      "insertLink",
      "insertFile",
      "insertVideo",
      "undo",
      "redo",
    ],
  },
  document: {
    toolbarButtons: [
      "fontFamily",
      "|",
      "fontSize",
      "|",
      "paragraphFormat",
      "|",
      "bold",
      "italic",
      "underline",
      "undo",
      "redo",
      "codeView",
    ],
    paragraphFormatSelection: true,
    heightMax: 800,
  },
}

export function optionsFor(presetName) {
  const preset = Object.prototype.hasOwnProperty.call(PRESETS, presetName) ? PRESETS[presetName] : PRESETS.note
  return {...BASE_OPTIONS, ...preset}
}
